import { APIRequest } from '@lynx/client-core/src/api'
import * as actions from '@lynx/client-core/src/store/profile'
import { allPermissions } from '@lynx/core/src/constants'
import { UserProfile } from '@lynx/core/src/interfaces/User'
import { getDefaultUserPermissions } from '@lynx/core/src/utils/permissionsUtils'
import { Action, Dispatch } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { ApplicationState } from 'store'
import { LOGIN, ProfileActionTypes, SET_LANG } from './types'

const loginInternal = (userProfile: UserProfile, loggedIn = true): ProfileActionTypes => {
	return {
		type: LOGIN,
		payload: { ...userProfile, authenticated: true, loggedIn }
	}
}

type login = (...args: Parameters<typeof actions.login>) => ThunkAction<Promise<string>, ApplicationState, null, Action<string>>
export const login = actions.login as unknown as login

type logout = (...args: Parameters<typeof actions.logout>) => ThunkAction<Promise<string>, ApplicationState, null, Action<string>>
export const logout = actions.logout as unknown as logout

export const loginUnregisteredUser =
	(accessToken: string, displayName: string): ThunkAction<Promise<string | void>, ApplicationState, null, Action<string>> =>
	async (dispatch: Dispatch): Promise<string | void> => {
		APIRequest.setAuthorization(accessToken)
		dispatch(
			loginInternal(
				{
					displayName: displayName,
					email: `${displayName}@lynxcloud.app`,
					gravatarUrl: '',
					permissions: getDefaultUserPermissions([...allPermissions]),
					isPro: false,
					isTermsAccepted: false,
					role: 0,
					userId: '',
					lang: ''
				},
				false
			)
		)
	}

type loginCookie = (...args: Parameters<typeof actions.loginCookie>) => ThunkAction<Promise<string>, ApplicationState, null, Action<string>>
export const loginCookie = actions.loginCookie as unknown as loginCookie

export const { setLang } = actions
